import Icon from "../svelte/Components/Icon.svelte";

var ctrl = function ($scope, $rootScope) {
  $scope.Icon = Icon;
};

ctrl.$inject = ["$scope", "$rootScope"];

tiz.controller("proviIconCtrl", ctrl);
tiz.directive("proviIcon", function () {
  return {
    scope: {
      type: "=",
      height: "=",
      width: "=",
      onPress: "=",
      className: "=",
      color: "=",
    },
    templateUrl: require("../templates/provi_icon.html"),
    controller: "proviIconCtrl",
  };
});
